import { create } from 'zustand'

export type MLPResult = {
    parking_results_uuid: string
    category: 'mlp' | 'confirmed_violator'
}
type FullScreenImageStore = {
    imageSrc: string
    imgTitle: string | React.ReactNode
    isOpenFullScreenImage: boolean
    openImageFullScreen: (imageSrc: string, imgTitle: string | React.ReactNode, maxSize?: string) => void
    closeFullScreenImage: () => void
    maxSize?: string
}

export const useFullScreenImageStore = create<FullScreenImageStore>((set) => ({
    isOpenFullScreenImage: false,
    imageSrc: '',
    imgTitle: '',
    openImageFullScreen: (imageSrc: string, imgTitle: string | React.ReactNode, maxSize) => {
        set({ imageSrc, imgTitle, isOpenFullScreenImage: true, maxSize })
    },
    closeFullScreenImage: () => {
        set({
            imageSrc: '',
            imgTitle: '',
            isOpenFullScreenImage: false,
            maxSize: ''
        })
    },
    maxSize: ''
}))
